import "./QualityControlComponent.scss";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect} from "react";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import ENV from "../../../constants/ENV";
import useSystemLockUpdateLabOs from "../../../shared/hooks/useSystemLockUpdateLabOs";

interface QualityControlComponentProps {

}

const QualityControlComponent = (props: QualityControlComponentProps) => {

    useSystemLockUpdateLabOs();
    const dispatch = useDispatch();

    const token = useSelector((state: any) => state.account.token);

    let LabQCUrl = `${ENV.LAB_OS_URL}?module=qc&token=${token}`;

    useEffect(() => {
        dispatch(setCurrentNavParams("Lab OS", "LabOS"));
        dispatch(setSideMenuView('compact'));
    }, [dispatch]);

    const {currentUser} = useSelector((state: any) => state.account);
    const {selectedLab} = useSelector((state: any) => state.selectedLab);
    if(currentUser?.roleObj?.code !== "labAdmin" && selectedLab){
        LabQCUrl = `${ENV.LAB_OS_URL}?module=qc&token=${token}&labId=${selectedLab}`
    }

    return (
        <div className={'quality-control-component lab-os-component'}>
            <iframe
                src={LabQCUrl}
                // src={`http://192.168.0.7:3005?token=${token}`}
                className={'labOs-iframe '}
                width="100%"
                height="100%"
                title={'LabOs'}
                loading={'eager'}
            />
        </div>
    );

};

export default QualityControlComponent;
